import axiosInstance from '@/shared/api/axios';
import type { PaginatedResponse } from '@/shared/types/api/common';
import type {
  ApiCharge,
  ApiChargeMarkPaidResponse,
  ApiChargesListParams,
  ApiChargesListResponse,
} from '@/shared/types/api/charges';

export const apiChargesList = async (
  params: ApiChargesListParams,
): Promise<ApiChargesListResponse> => {
  const { data } = await axiosInstance.get<PaginatedResponse<ApiCharge>>('/charges', {
    params,
  });
  return data.results;
};

export const apiChargeMarkPaid = async (
  id: number,
): Promise<ApiChargeMarkPaidResponse> => {
  const { data } = await axiosInstance.post<ApiChargeMarkPaidResponse>(
    `/charges/${id}/mark-paid`,
  );
  return data;
};

export const apiChargeMarkUnpaid = async (id: number): Promise<ApiCharge> => {
  const { data } = await axiosInstance.post<ApiCharge>(`/charges/${id}/mark-unpaid`);
  return data;
};
